// frontend/src/pages/CookiesPolicy.jsx
// This component renders a minimal Cookies Policy page with increased top spacing
import { useEffect } from "react";
import HeaderSimple from "../components/pages/home/HeaderSimple";
import Footer from "../components/pages/home/Footer";
import { updatePageTitle } from "../utils/titleUtils";

// This is the main cookies policy page component
const CookiesPolicy = () => {
  // This sets the browser tab title and scrolls to top when the page loads
  useEffect(() => {
    updatePageTitle("Cookies Policy");
    window.scrollTo(0, 0);
  }, []);

  // This returns minimal layout without containers, borders or shadows
  return (
    <div className="min-h-screen bg-bg-60">
      {/* This shows the simple header at the top */}
      <HeaderSimple />

      {/* This is the main content with top margin and simple typography */}
      <main className="pt-48 pb-20 px-6">
        {/* This wraps the content to a max width similar to the home page */}
        <div className="w-[90%] max-w-5xl mx-auto">
          {/* This is the page title and effective date centered only */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-fg-50 mb-2">Cookies Policy</h1>
            <p className="text-fg-60">Effective date: November 15, 2025</p>
          </div>

          {/* This section explains what cookies are */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">What Are Cookies</h2>
            <p className="text-fg-60">
              Cookies are small text files placed on your device by websites. They help remember your settings, keep you
              signed in, and understand how you use the service. We use both session cookies (deleted when you close your
              browser) and persistent cookies (stay until they expire or you delete them).
            </p>
          </section>

          {/* This section explains types and purposes */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Types We Use</h2>
            <p className="text-fg-60">
              We use necessary cookies to deliver core features, preference cookies to remember your theme and settings,
              and analytics cookies to measure usage. Some cookies may be set by third‑party providers that help us operate
              or improve the service.
            </p>
          </section>

          {/* This section explains managing cookies */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Managing Cookies</h2>
            <p className="text-fg-60">
              You can control cookies through your browser settings and opt‑out of certain analytics. Disabling cookies may
              impact functionality, including keeping you signed in and saving preferences.
            </p>
          </section>

          {/* This section explains changes and contact */}
          <section>
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Changes and Contact</h2>
            <p className="text-fg-60">
              We may update this policy as our use of cookies evolves. If you have questions, contact us at
              <span className="font-medium"> abc@Leebai.com</span>.
            </p>
          </section>
        </div>
      </main>

      {/* This shows the global footer at the bottom */}
      <Footer />
    </div>
  );
};

export default CookiesPolicy;